import { $, $$ } from 'utils/dom';
import Shower from 'modules/shower';
import FocusTrap from 'modules/focus-trap';

class TodayPlus {
  constructor(handler, target) {
    this.handler = handler;
    this.target = target;
    this.closeButton = $('.today-plus__close-button', target);
  }

  initTodayPlusShower() {
    const handler = this.handler;
    const target = this.target;

    const mainTodayPlusShower = new Shower({
      target,
      handler,
      easing: 'ease',
      duration: 450,
      initOpened: false,
      openClassName: 'is-open',
    });
    mainTodayPlusShower.init();

    this.closeButton.addEventListener('click', () => {
      mainTodayPlusShower.close();
    });

    window.addEventListener('keydown', event => {
      if (event.key === 'Escape' && target.classList.contains('is-open')) {
        mainTodayPlusShower.close();
      }
    });

    this.initTodayPlusSubShowers(target);
  }

  initTodayPlusSubShowers(parent) {
    const handlers = $$('.today-plus__accordion-button', parent);
    const togglers = handlers.map((handler, i) => {
      const target = handler.parentElement.nextElementSibling;
      return new Shower({
        target,
        handler,
        easing: 'ease',
        duration: 400,
        initOpened: i === 0 && window.innerWidth > 769,
        openClassName: 'is-open',
      });
    });

    togglers.forEach(toggle => {
      // send in the other Shower instances to close when one opens
      toggle.closeInstances = togglers.filter(t => t !== toggle);
      toggle.init();
    });
  }

  init = () => {
    this.initTodayPlusShower();
  };
}

const todayPlusButton = $('.toggle-today-plus');
const todayPlus = $('.today-plus');

todayPlusButton &&
  todayPlus &&
  new TodayPlus(todayPlusButton, todayPlus).init();

const closeButton = $('.today-plus__close-button');

closeButton && new FocusTrap(todayPlusButton, todayPlus, closeButton).init();
